import { render, staticRenderFns } from "./approved-training-table.vue?vue&type=template&id=07962839&"
import script from "./approved-training-table.vue?vue&type=script&lang=js&"
export * from "./approved-training-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports